export default "__VITE_ASSET__B4ZQr3M4__"